export default "__VITE_ASSET__DYI5hHlb__"